// Module
var code = `<div class="js-full-log-panel">
    <div class="js-full-log-toolbar">
        <terceraButton name="startLoggin"
                        text="Start logging"
                        terceraButtonStyle="js-button-gray25 js-startLog-btn"
                        on-btnClick="@this.StartStopLogging()" />
        <terceraComboBox name="codesCBFullLog" />
        <terceraButton name="add"
                        text="Add Msg Id"
                        terceraButtonStyle="js-button-gray25 js-add-btn"
                        on-btnClick="@this.AddMsgCodeForLogging()" />
        <terceraTextBox name="codesTBFullLog" />

        <terceraButton name="clear"
                        text="Clear"
                        terceraButtonStyle="js-button-gray25 js-clear-btn"
                        on-btnClick="@this.ClearTable()" />
    </div>

    <div class="js-full-log-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;